import { Component, OnInit, Input, ComponentRef, ViewChild, EventEmitter, Output,HostListener} from '@angular/core';
import { AgentscriptService } from '../services/agentscript-services/agentscript.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
declare var $ : any;
import Swal from 'sweetalert2/dist/sweetalert2.js';

//var dt = require('datatables.net');
import { StandardUIService } from '../services/standardui-service/standardui-service';
import { ObjectController } from '../services/object-controller/objectcontroller.service';
import { BehaviorSubject } from 'rxjs';
@Component({
  selector: 'app-report-view',
  templateUrl: './report-view.component.html',
  styleUrls: ['./report-view.component.scss']
})
export class ReportViewComponent implements OnInit {
  @Input() reportId;
  @Input() context;
  constructor(
    private agentScriptService:AgentscriptService,
    private modalService: NgbModal,
    private standardUIService:StandardUIService,
    private objcontroller:ObjectController
    ) { }
  displayName:any;
  reportData:any;
  loading:boolean = false;
  formView:boolean = false;
  listView:boolean = true;
  tableHeading = [];
  tableRows:any = [];
  newRow:any = [];
  entity:string="";
  formViewdata:any = [];
  editable:any;
  @Output() componentSelection = new EventEmitter<any>();
  @Output() loadcomplet = new EventEmitter<any>();
  
  @ViewChild('reportPopupForm') public reportPopupForm;
  private cmpRef: ComponentRef<any>;
  
  resultArray:any = [];
  searchKeys:any = [];
	sortBy = '';
	sortDesc = false;
	perPage = 10;
	totalItems = 0;
	filterVal = '';
	currentPage = 1;
  infoMsg: boolean;
  objectMetaData:any;
  triageStatus:boolean;
  
  ngOnInit() {

    console.log(this.context);    

    this.formViewdata = [];       
    if(this.context){
      
      let repPayload = {
        "reportId":this.reportId,
          "context":{
          "entityName":this.context.entityName,
          "id":this.context.id
          }
        }
        //console.log('Report payload - ',repPayload);
        this.agentScriptService.getReportdata(repPayload).subscribe((res:any)=>{
          this.entity = res.entity;
          this.tableHeading = res.columns;
          this.editable = res.editable;         
          this.objectMetaData = res.objMetadata;
          this.triageStatus = this.context.triageStatus;
          //console.log(this.editable+'--'+this.triageStatus);
          if(this.editable)
          {
            this.newRow = res.newRow;
          }
         
          this.tableRows = res.rows;
          if(res.editable){
            this.FormView();
          }         
          setTimeout(()=>{            
            // ($('.pane:visible .data-table-'+this.reportId) as any).dataTable({
            //   "language": {
            //     "paginate": {
            //       "previous": "",
            //       "next":""
            //     },
            //     "lengthMenu": "Records per page _MENU_ ",
            //     //dom: 'rt',
            //     "order": [],
            //     // "columnDefs": [
            //     //   { "orderable": false, "targets": 0 },
            //     //   { "orderable": false, "targets": 1 },
            //     //   { "orderable": false, "targets": 2 },
            //     //   { 'orderable': false, 'targets': 3 },
            //     //   { 'orderable': false, 'targets': 4 }
            //     // ],
            //     paging: false,
            //     fixedHeader: true,
            //     scrollCollapse: true,
            //     scrollX: true,
            //     scrollY: '300px',
            //   }
            // });
            // let dataTable = ($('.pane:visible .data-table-' + this.reportId) as any).DataTable();
            // dataTable.order([]).draw();
            // dataTable.columnDefs([
            //         { "orderable": false, "targets": 1 },
            //         { "orderable": false, "targets": 2 },
            //         { 'orderable': false, 'targets': 3 },
            //         { 'orderable': false, 'targets': 4 }
            //       ]).draw();
            // for (let i = 0; i < this.tableHeading.length; i++) {
            //   dataTable.columnDefs([
            //     { "orderable": false, "targets": i },                
            //   ]).draw();
            // }
          },500);
         
        })
        
    }

    
  }
  ngAfterViewInit(){
    //this.loadCompleteEmitter({'content':'Loaded'});
   
    //$('.form-view-content').find('input,select,textarea').attr('readonly','true');

  }
  convertDate(data){
    return this.standardUIService.getDate(data);
  }
  convertDateTime(data){
    return this.standardUIService.convertToEST(data);
  }
  OpenForm(e,reportData){
    //console.log(reportData);
    this.modalService.open(this.reportPopupForm, { backdrop: 'static', keyboard: false, windowClass: 'modal-lg animate reportForm' })
  }
  Save(e){
    // let submittedForm =jq(e.target).parents('.report-form');
    // console.log(this.standardUIService.serializeObject(submittedForm));
  }
  onSubmit(form){
    //console.log(form.valid);
    
    let formValue:any = {};
    
    for(let i in form.value){
      
      if(form.value[i]){
        if(form.value[i] == 'true' || form.value[i] == 'false')
          {
            formValue[i] = (form.value[i] == 'true') ? true : false;
          }else{
            formValue[i] = form.value[i];
          }
      }
    }
    
    let payload = {
      "entityName": this.entity,
      "report": {
          "reportId": this.reportId,
          "context": {
            'id':this.context.id,
            'entityName':this.context.entityName
          }
      },
      "payLoad": formValue
    };

    console.log(payload);
    //return false;
    this.objcontroller.reportFormCreate(payload).subscribe((data:any)=>{
          console.log(data);
          if(data.error){
            Swal.fire('Oops...!', data.error, 'error');
          } else {
            if(data.payLoad.hasOwnProperty('id')){
              form.controls['id'].setValue(data.payLoad.id);
            }
            $(".pane:visible .dynamic-form").find('.submit-form').eq(0).trigger('click');
            Swal.fire('Success!', 'Saved successfully!', 'success');
          }    
    })
  }
  FormView(){
    this.formViewdata = [];
    this.formView = true;
    this.listView = false;
    
    if(this.newRow !=null && this.tableRows.length ==0)
    {
      this.tableRows.push(this.newRow);
    }
    
    for(let i=0;i<this.tableRows.length;i++){
      let row = [];
      let tempObj:any = {};tempObj.rec = [];
      for(let j=0;j<this.tableRows[i].length;j++){
       //tempObj.name = this.tableRows[i][0].value + ' ' +this.tableRows[i][1].value;
       tempObj.name = this.entity;
       if(this.tableRows[i][j].dataType == "datetime" || this.tableRows[i][j].dataType == "date"){
          this.tableRows[i][j].value = this.standardUIService.getDateByFormat(this.tableRows[i][j].value,'-','ymd'); 
        }
        if(this.tableRows[i][j].dataType == "picklist"){          
            let objDetails = this.objectMetaData.columnNames[this.tableRows[i][j].coulmnName];
            let sortable:any = [];  
              if(objDetails.hasOwnProperty('pickListValues')){   
                         
                  for (var it in objDetails.pickListValues.newIdValues) {                            
                      if(objDetails.pickListValues.newIdValues[it].active == true)
                      {
                          let objSorted:any = {};
                          objSorted.option_label = objDetails.pickListValues.newIdValues[it].value;
                          objSorted.option_value = parseInt(it.replace('key_',''));
                          sortable.push(objSorted);
                      }                            
                  }
                if(this.tableRows[i][j].coulmnName == 'pregnancyoutcome'){
                  sortable.sort(this.standardUIService.SortByValue); 
                }  else {
                  sortable.sort(this.standardUIService.SortByName); 
                }
                
                this.tableRows[i][j].pickListValues = sortable;
            }          
        }       
        if(!this.tableRows[i][j]['value']){        
            this.tableRows[i][j].value = '';          
        }       
      }
      tempObj.rec = this.chunk(this.tableRows[i],3);
      row = tempObj;              
      this.formViewdata.push(row);
      
     // $('.form-view-content').find('input,select,textarea').attr('readonly','true');
      
    }   
    //console.log(this.formViewdata);
    //  setTimeout(function(){
    //   jq(".form-view-accordion").eq(0).find(".form-view-header").trigger('click');
    // },500)
    
  }
  ListView(e){
    
    this.formView = false;
    this.listView = true;
   
    // setTimeout(()=>{
      
    //   (jq('.pane:visible .data-table-'+this.reportId) as any).dataTable({
    //     "language": {
    //       "paginate": {
    //         "previous": "«",
    //         "next":"»"
    //       }
    //     }
    //   });
    // },500);
  }
  chunk(arr, size) {
    var newArr = [];
    for (var i=0; i<arr.length; i+=size) {
      newArr.push(arr.slice(i, i+size));
    }
    return newArr;
  }
  
  inlineForm(e,reportData){    
    $(e.target).next().slideToggle();
  }
  
  public componentSelectionEmitter(componentData: object) {
    //console.log(componentData);
    this.componentSelection.emit(componentData);
  }
  public loadCompleteEmitter(componentData: object) {
    //console.log(componentData);
    this.loadcomplet.emit(componentData);
  }
  
  addNew(){
    
    let newTableRow:any = [];
    let nr = JSON.parse(JSON.stringify(this.newRow));
    newTableRow.push(nr);
    for(let i=0;i<newTableRow.length;i++){
      let row = [];
      let tempObj:any = {};tempObj.rec = [];
      for(let j=0;j<newTableRow[i].length;j++){
       //tempObj.name = this.tableRows[i][0].value + ' ' +this.tableRows[i][1].value;
       tempObj.name = this.entity;  
       if(newTableRow[i][j].coulmnName == "id"){
        newTableRow[i][j].value = '';
       }     
       if(newTableRow[i][j].dataType == "datetime" || newTableRow[i][j].dataType == "date"){
        newTableRow[i][j].value = this.standardUIService.getDateByFormat(newTableRow[i][j].value,'-','ymd'); 
        }
        if(newTableRow[i][j].dataType == "picklist"){          
            let objDetails = this.objectMetaData.columnNames[newTableRow[i][j].coulmnName];
            let sortable:any = [];  
              if(objDetails.hasOwnProperty('pickListValues')){             
                  for (var it in objDetails.pickListValues.newIdValues) {                            
                      if(objDetails.pickListValues.newIdValues[it].active == true)
                      {
                          let objSorted:any = {};
                          objSorted.option_label = objDetails.pickListValues.newIdValues[it].value;
                          objSorted.option_value = parseInt(it.replace('key_',''));
                          sortable.push(objSorted);
                      }                            
                  }
                sortable.sort(this.standardUIService.SortByName); 
                newTableRow[i][j].pickListValues = sortable;
            }          
        }        
        if(!newTableRow[i][j]['value']){
          newTableRow[i][j].value = ''; 
        }        
      }
      tempObj.rec = this.chunk(newTableRow[i],3);
      row = tempObj; 
      this.formViewdata.push(row);      
    } 
  }
  removeRow(i){
    if(i > 0) this.formViewdata.splice(i,1);
  }
  ngOnDestroy() {
    if(this.cmpRef) {
        this.cmpRef.destroy();
    }
  }
  refresh(){
    this.ngOnInit();
  }
  auto_grow(element) {
    element.target.style.height = "32px";
    element.target.style.height = (element.target.scrollHeight)+"px";
  }
  randomId() {
    return Math.floor(Math.random() * (999 - 100 + 1) + 100) + Date.now() + 'report';
  }
}
